import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getReportGenerationFailure } from './errorMessages';
import { getErrorMessageForCode, getAlertTimeoutMsForCode } from './errorCodes';
import { DEFAULT_ALERT_TIME } from '@instructure/quiz-common';
var DEFAULT_ERROR_MSG = getReportGenerationFailure();
export var generateReports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var setGenerationInProgress, setStatusPollingInProgress, generateAnalysis, analysisType, filter, addError, onError, _requestResult$respon, requestResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setGenerationInProgress = _ref.setGenerationInProgress, setStatusPollingInProgress = _ref.setStatusPollingInProgress, generateAnalysis = _ref.generateAnalysis, analysisType = _ref.analysisType, filter = _ref.filter, addError = _ref.addError;
          onError = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
              var errorMessage, alertTimeout, _responseBody$error, responseBody, errorCode;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    errorMessage = DEFAULT_ERROR_MSG;
                    alertTimeout = DEFAULT_ALERT_TIME;
                    _context.prev = 2;
                    _context.next = 5;
                    return error.response.json();
                  case 5:
                    responseBody = _context.sent;
                    errorCode = responseBody === null || responseBody === void 0 || (_responseBody$error = responseBody.error) === null || _responseBody$error === void 0 ? void 0 : _responseBody$error.code;
                    if (errorCode) {
                      errorMessage = getErrorMessageForCode(errorCode, DEFAULT_ERROR_MSG);
                      alertTimeout = getAlertTimeoutMsForCode(errorCode);
                    }
                    _context.next = 12;
                    break;
                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](2);
                  case 12:
                    _context.prev = 12;
                    addError(errorMessage, alertTimeout);
                    setGenerationInProgress(false);
                    return _context.finish(12);
                  case 16:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[2, 10, 12, 16]]);
            }));
            return function onError(_x2) {
              return _ref3.apply(this, arguments);
            };
          }();
          _context2.prev = 2;
          setGenerationInProgress(true);
          _context2.next = 6;
          return generateAnalysis(filter, onError, analysisType);
        case 6:
          requestResult = _context2.sent;
          if (requestResult !== null && requestResult !== void 0 && (_requestResult$respon = requestResult.response) !== null && _requestResult$respon !== void 0 && _requestResult$respon.ok) {
            setStatusPollingInProgress(true);
          }
          _context2.next = 14;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          addError(DEFAULT_ERROR_MSG);
          setGenerationInProgress(false);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 10]]);
  }));
  return function generateReports(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default generateReports;